import React, { useId } from 'react';

interface SorenaLogoProps {
  className?: string;
  glow?: boolean;
}

/**
 * Official Sorena IT Brand Logo (Vector SVG)
 * Scaled with integer coordinates and unique gradient IDs for bulletproof rendering on mobile and tablet.
 */
export const SorenaLogo: React.FC<SorenaLogoProps> = ({ 
  className = "w-8 h-8",
  glow = false
}) => {
  const rawId = useId();
  const gradId = `sorena_gold_${rawId.replace(/[^a-zA-Z0-9]/g, '_')}`;

  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 911 618" 
      preserveAspectRatio="xMidYMid meet"
      className={`${className} ${glow ? 'drop-shadow-[0_0_8px_rgba(251,196,76,0.6)]' : ''} shrink-0 transition-transform duration-200`}
      fillRule="evenodd" 
      clipRule="evenodd"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      imageRendering="optimizeQuality"
      aria-label="Sorena IT Official Logo"
    >
      <defs>
        <linearGradient id={gradId} gradientUnits="userSpaceOnUse" x1="-295" y1="808" x2="1306" y2="-257">
          <stop offset="0" stopColor="#FBC44C" stopOpacity="1" />
          <stop offset="0.101961" stopColor="#A25D37" stopOpacity="1" />
          <stop offset="0.301961" stopColor="#E8AC44" stopOpacity="1" />
          <stop offset="0.478431" stopColor="#F5F19C" stopOpacity="1" />
          <stop offset="0.568627" stopColor="#E8AC44" stopOpacity="1" />
          <stop offset="0.878431" stopColor="#693A2D" stopOpacity="1" />
          <stop offset="1" stopColor="#693A2D" stopOpacity="1" />
        </linearGradient>
      </defs>
      <g>
        <path 
          fill={`url(#${gradId})`} 
          fillRule="nonzero" 
          d="M1 618l0 -1 0 0c0,-1 0,-5 -1,-11l0 0 0 -1c-2,-61 3,-339 306,-394 342,-62 533,-94 605,-211 0,0 3,256 -343,301 -347,46 -556,160 -567,317zm92 -89c-18,13 -28,22 -28,22 0,0 138,-165 350,-183 212,-17 324,-54 379,-92 0,0 -75,157 -358,168 -196,9 -298,56 -343,85zm13 55c0,0 125,-84 269,-91 144,-6 247,-32 283,-49 0,0 -126,108 -294,124 -168,16 -258,16 -258,16zm-13 -55c-20,13 -28,22 -28,22"
        />
      </g>
    </svg>
  );
};
